import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Flex, Image, Text, useColorModeValue } from '@chakra-ui/react';
import { HSeparator } from 'components/separator/Separator';
import nimsiClinicLogo from 'assets/img/brand/nimsi-clinic-logo.jpg';
import { useAuth } from 'contexts/AuthContext';
import routes from 'routes';
import { firstAllowedAdminPath } from 'constants/permissions';

const BRAND_ACCENT = '#5aadd8';

export function SidebarBrand() {
  const { user } = useAuth();
  const homePath = firstAllowedAdminPath(user, routes);
  const titleColor = useColorModeValue('navy.700', 'white');
  const subtitleColor = useColorModeValue('gray.500', 'gray.400');

  return (
    <Flex align="center" direction="column" w="100%">
      <Flex
        as={RouterLink}
        to={homePath}
        align="center"
        gap="14px"
        w="100%"
        px="10px"
        py="18px"
        _hover={{ textDecoration: 'none', bg: 'transparent' }}
        _active={{ bg: 'transparent' }}
        _focus={{ boxShadow: 'none' }}
      >
        <Box
          flexShrink={0}
          w="56px"
          h="56px"
          borderRadius="16px"
          overflow="hidden"
          boxShadow={`0 8px 24px rgba(1, 65, 109, 0.28)`}
          border="2px solid"
          borderColor={useColorModeValue('white', 'whiteAlpha.200')}
        >
          <Image
            src={nimsiClinicLogo}
            alt="NIMSI Clinic"
            w="100%"
            h="100%"
            objectFit="cover"
          />
        </Box>
        <Flex direction="column" align="flex-start" minW={0} flex="1">
          <Flex align="baseline" gap="6px" flexWrap="wrap">
            <Text
              fontSize="xl"
              fontWeight="800"
              letterSpacing="0.04em"
              lineHeight="1"
              color={titleColor}
            >
              NIMSI
            </Text>
            <Text
              fontSize="xl"
              fontWeight="800"
              letterSpacing="0.12em"
              lineHeight="1"
              color={BRAND_ACCENT}
            >
              Clinic
            </Text>
          </Flex>
          <Text
            fontSize="xs"
            fontWeight="600"
            letterSpacing="0.22em"
            textTransform="uppercase"
            color={subtitleColor}
            mt="6px"
          >
            CRM
          </Text>
        </Flex>
      </Flex>
      <HSeparator mb="20px" w="100%" />
    </Flex>
  );
}

export default SidebarBrand;
